/* SunnyLot Kids - WhatsApp Touch System JS */
(function () {
  'use strict';

  var WA_URL = 'https://wa.me/8618060785929';
  var BUBBLE_ID = 'sl-wa-bubble-global';
  var FLOAT_BTN_ID = 'sl-wa-float-btn';
  var EXIT_BUBBLE_ID = 'sl-exit-bubble';
  var exitShown = false;

  // ---- Toggle bubble open/close ----
  function openBubble() {
    var bubble = document.getElementById(BUBBLE_ID);
    if (bubble) {
      bubble.classList.add('is-open');
      bubble.setAttribute('aria-hidden', 'false');
    }
  }

  function closeBubble() {
    var bubble = document.getElementById(BUBBLE_ID);
    if (bubble) {
      bubble.classList.remove('is-open');
      bubble.setAttribute('aria-hidden', 'true');
    }
  }

  function toggleBubble() {
    var bubble = document.getElementById(BUBBLE_ID);
    if (bubble && bubble.classList.contains('is-open')) {
      closeBubble();
    } else {
      openBubble();
    }
  }

  // ---- Exit intent (desktop only, fires once) ----
  function initExitIntent() {
    if (exitShown) return;
    var el = document.getElementById(EXIT_BUBBLE_ID);
    if (!el) return;
    document.addEventListener('mouseleave', function onLeave(e) {
      if (e.clientY > 20) return;
      if (exitShown) return;
      exitShown = true;
      el.classList.add('is-visible');
      document.removeEventListener('mouseleave', onLeave);
    });
    var closeBtn = el.querySelector('.sl-exit-bubble__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        el.classList.remove('is-visible');
      });
    }
  }

  // ---- Init ----
  function init() {
    // Float button
    var floatBtn = document.getElementById(FLOAT_BTN_ID);
    if (floatBtn) {
      floatBtn.addEventListener('click', function () { toggleBubble(); });
    }

    // Close button inside bubble
    var closeBtns = document.querySelectorAll('.sl-wa-bubble__close');
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { closeBubble(); });
    });

    // Any .sl-trigger-bubble button opens the shared bubble
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.sl-trigger-bubble');
      if (trigger) {
        e.preventDefault();
        openBubble();
        // Scroll bubble into view on mobile
        var bubble = document.getElementById(BUBBLE_ID);
        if (bubble) { bubble.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      }
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (e.target.closest('#' + BUBBLE_ID)) return;
      if (e.target.closest('#' + FLOAT_BTN_ID)) return;
      if (e.target.closest('.sl-trigger-bubble')) return;
      closeBubble();
    });

    // Exit intent
    initExitIntent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
